import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer } from '@angular/platform-browser';
import { TextContentService } from '@core/text-content/text-content.service';
import { convertToDate } from '@core/utils/date.utils';
import { WindowService } from '@core/window-actions';
import { FlightTrackerCopy } from '@dynamic-components/flight-tracker/types/flight-tracker-copy.type';
import { memo } from '@shared/ui';
import format from 'date-fns/format';
import { JbDialogService } from 'jb-component-library';
import { Observable } from 'rxjs';

import { FLIGHT_TRACKER_CONFIG } from '../../flight-tracker.config';
import { FlightTrackerLeg } from '../../types/flight-tracker-leg.type';
import { FlightTrackerResultsService } from '../flight-tracker-results.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker-results-desktop-dialog',
  templateUrl: './flight-tracker-results-desktop-dialog.component.html',
  styleUrls: ['./flight-tracker-results-desktop-dialog.component.scss'],
  providers: [FlightTrackerResultsService],
})
export class FlightTrackerResultsDesktopDialogComponent implements OnInit {
  private _destroy = inject(DestroyRef);
  departureDate: any;
  timeDepartMap: any;
  dateDepartMap: string;
  timeArrivalMap: any;
  URL: string;
  dialogSecondNewArrival: any;
  dialogSecondScheduledArrival: any;
  dialogSecondNewDeparture: any;
  dialogSecondScheduledDeparture: any;
  dialogSecondDestinationGate: any;
  dialogSecondDestinationTerm: any;
  dialogSecondDestination: any;
  dialogSecondOriginGate: any;
  dialogSecondOriginTerminal: any;
  dialogSecondOrigin: any;
  dialogSecondStatus: any;
  dialogSecondFlightNo: any;
  dialogNewArrival: any;
  dialogScheduledArrival: any;
  dialogNewDeparture: any;
  dialogScheduledDeparture: any;
  dialogDestinationGate: any;
  dialogDestinationTerminal: any;
  dialogDestination: any;
  dialogOriginGate: any;
  dialogOriginTerminal: any;
  dialogOrigin: any;
  dialogStatus: any;
  dialogFlightNo: any;
  dateArrivalMap: any;
  dialogScheduledOriginAirport: any;
  dialogScheduledDestinationAirport: any;
  isMobile: boolean;
  currentTime = new Date();
  config = FLIGHT_TRACKER_CONFIG;

  flightTrackerText$: Observable<FlightTrackerCopy>;

  constructor(
    private windowService: WindowService,
    private flightTrackerResultsService: FlightTrackerResultsService,
    private sanitizer: DomSanitizer,
    public dialogService: JbDialogService,
    private cdRef: ChangeDetectorRef,
    private textContentService: TextContentService,
  ) {
    this.windowService.windowSizeChanged.subscribe(size => {
      this.isMobile = !!size.small;
    });
  }

  ngOnInit() {
    this.flightTrackerText$ = this.textContentService
      .getJsonAsset('flight-tracker')
      .pipe(takeUntilDestroyed(this._destroy));
  }

  @memo()
  convertTime(time: string) {
    return this.flightTrackerResultsService.convertTime(time);
  }

  @memo()
  setStatusColor(status: string): string {
    return this.flightTrackerResultsService.setStatusColor(status);
  }

  calculateRemainingTime(time: string) {
    return this.flightTrackerResultsService.calculateRemainingTime(time);
  }

  closeDialog() {
    this.dialogService.closeDialog();
  }

  handleData = (departureDate: any, result: FlightTrackerLeg) => {
    this.departureDate = departureDate;
    this.dialogFlightNo = result.flightNo;
    this.dialogStatus = result.flightStatus;
    this.dialogOrigin = result.originAirport;
    this.dialogOriginTerminal = result.originTerminal;
    this.dialogOriginGate = result.originGate;
    this.dialogDestination = result.destinationAirport;
    this.dialogDestinationTerminal = result.destinationTerminal;
    this.dialogDestinationGate = result.destinationGate;
    this.dialogScheduledDeparture = result.scheduledDeparture;
    this.dialogNewDeparture = result.actualDeparture;
    this.dialogScheduledArrival = result.scheduledArrival;
    this.dialogNewArrival = result.actualArrival;
    this.dateArrivalMap = format(
      convertToDate(result.actualArrival),
      'yyyy/MM/dd',
    );
    this.dateDepartMap = format(
      convertToDate(result.actualDeparture),
      'yyyy/MM/dd',
    );
    if (result.actualArrival && result.actualDeparture) {
      this.timeArrivalMap = result.actualArrival.slice(11, 19);
      this.timeDepartMap = result.actualDeparture.slice(11, 19);
    }
    this.dialogScheduledOriginAirport = result.scheduledOriginAirport;
    this.dialogScheduledDestinationAirport = result.scheduledDestinationAirport;
    this.URL = `${
      this.config.FLIGHT_MAP.PROD +
      this.config.FLIGHT_MAP.MIDDLEPARAMS +
      this.config.FLIGHT_MAP.DEPARTURE
    }=${this.dialogOrigin}&${this.config.FLIGHT_MAP.FLIGHTNO}=${
      this.dialogFlightNo
    }&${this.config.FLIGHT_MAP.ETA}=${this.dateArrivalMap}, ${
      this.timeArrivalMap
    }&${this.config.FLIGHT_MAP.DEPARTURETIME}=${this.dateDepartMap}, ${
      this.timeDepartMap
    }`;
    this.cdRef.markForCheck();
  };
}
